import styled from "styled-components";

import { fontSizes } from "../../shared/styles/typography";
import { pageRoot } from "../../styles/pageRoot";

export const Container = styled.div`
  ${pageRoot}
  padding: 16px;
  gap: 20px;
`;

export const InfoCard = styled.div`
  background: #fff;
  border-radius: 24px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  text-align: center;

  h2 {
    font-size: ${fontSizes.xl}px;
    font-weight: var(--font-weight-bold);
    color: #1e293b;
    margin-bottom: 12px;
  }

  p {
    font-size: ${fontSizes.base}px;
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 24px;
  }
`;

export const CharactersBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;

  img {
    object-fit: contain;
  }

  .lilla {
    width: 90px;
    height: 110px;
  }
  .bili {
    width: 80px;
    height: 100px;
  }
  .batata {
    width: 80px;
    height: 100px;
  }
`;

export const PixCard = styled.div`
  background: #fff;
  border-radius: 24px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  h3 {
    font-size: ${fontSizes.base}px;
    font-weight: var(--font-weight-semibold);
    color: #1e293b;
  }

  .bank-logo {
    width: 48px;
    height: 48px;
  }

  .pix-label {
    font-size: ${fontSizes.sm}px;
    font-weight: 600;
    color: #64748b;
    align-self: flex-start;
  }

  .pix-key {
    font-size: ${fontSizes.base}px;
    font-weight: var(--font-weight-bold);
    color: #4614bb;
    letter-spacing: 0.5px;
    background: #f1f5f9;
    padding: 12px;
    border-radius: 12px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #e2e8f0;
    }
  }

  .pix-details {
    width: 100%;
    text-align: left;

    p {
      font-size: ${fontSizes.sm}px;
      color: #64748b;
      margin: 2px 0;
    }

    strong {
      color: #1e293b;
    }
  }
`;

export const ApoiaBtn = styled.button`
  background: #eb4a3b;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 16px;
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-semibold);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: transform 0.2s;
  box-shadow: 0 4px 12px rgba(235, 74, 59, 0.3);

  &:active {
    transform: scale(0.98);
  }

  span {
    font-size: ${fontSizes.xl}px;
  }
`;

export const Subtitle = styled.p`
  font-size: ${fontSizes.sm}px;
  color: #64748b;
  text-align: center;
  margin-top: -10px;
`;
